import { InjectionToken } from '@angular/core';

export interface IStudentMusicService {
    playSound(path: string, volume?: number): any;
}

export const STUDENT_MUSIC_SERVICE_TOKEN = new InjectionToken<IStudentMusicService>('IStudentMusicService');

